import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Employee_id: 0,
    Employee_name: ''
  },
  getters,
  mutations: {
    SelectEmployee(state, v) {
      console.log('aaaa=', v)
      state.Employee_id = v.Employeeid
      state.Employee_name = v.Employeename
    }
  },
  // SelectEmployeename(state, v) {
  //   console.log('aaaa=', v)
  //   // this.state.Employee_id = v.Employeeid
  //   this.state.Employee_name = v
  // }
  // },
  // actions: {
  // },
  modules: {
    user
  }
})
